import * as React from "react";
// import { pure } from 'recompose'
import { Link } from "react-router-dom";
import * as Paths from "@tunnel-enums/index";
import * as Lodash from "lodash";
import * as StyledComponent from "@tunnel-components/@sharded/@styled/styled";
import * as i18next from "i18next";
/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (
  props: ComponentInterface
): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const { onResetSection, cameraparams, onResetCamera, isVisible } = props;

  /**
   * @constant
   * @déclaration - const permet de créer une constante ( variable )
   * nommée accessible uniquement en lecture.
   * @module Lodash : Lodash est une bibliothèque JavaScript elle fournit
   * des fonctions utilitaires pour les tâches de programmation courantes
   * @infos "https://lodash.com/"
   */
  /**
   * @description : Cette expression definit l'existence d'un élement
   * @const
   * @type { boolean }
   * @name cameraIsUndefined
   */
  const cameraIsUndefined: boolean = Lodash.isUndefined(cameraparams); //

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @infos "https://reactjs.org"
   */
  return (
    <StyledComponent.ModalContainer
      isVisible={isVisible}
      style={{ backgroundColor: "transparent" }}
    >
      <StyledComponent.ModalContainerInsider
        isVisible={isVisible}
        style={{
          overflow: "visible",
          width: "500px",
          backgroundColor: "white",
          padding: "20px",
          boxSizing: "border-box",
        }}
      >
        <div className="title-sequence-infos"> {i18next.t("attention")}</div>
        <div className="sequence-content">
          <p>
            {" "}
            {i18next.t("cette section (ou camera) a ete segmentee en totalite")}
          </p>
          <p>{i18next.t("etes-vous sur de vouloir refaire la segmentation")}</p>
        </div>
        <div className="modalBtn">
          {cameraIsUndefined && (
            <span className="borderGradian" onClick={onResetSection}>
              <span
                className="btnSecondary "
                style={{ backgroundColor: "white", overflow: "visible" }}
              >
                <span className="textGradianlarge">{i18next.t("oui")}</span>
              </span>
            </span>
          )}
          {!cameraIsUndefined && (
            <span className="borderGradian" onClick={onResetCamera}>
              <span
                className="btnSecondary "
                style={{ backgroundColor: "white", overflow: "visible" }}
              >
                <span className="textGradianlarge">{i18next.t("oui")}</span>
              </span>
            </span>
          )}

          {cameraIsUndefined && (
            <Link to={Paths.PathsNamesEnums.CAMERAHOME}>
              <span className="borderGradian">
                <span
                  className="btnSecondary "
                  style={{ backgroundColor: "white", overflow: "visible" }}
                >
                  <span className="textGradianlarge">{i18next.t("non")}</span>
                </span>
              </span>
            </Link>
          )}
          {!cameraIsUndefined && (
            <Link
              to={`${Paths.PathsNamesEnums.CAMERASETTINGID}${cameraparams}`}
            >
              <span className="borderGradian">
                <span
                  className="btnSecondary "
                  style={{ backgroundColor: "white", overflow: "visible" }}
                >
                  <span className="textGradianlarge">{i18next.t("non")}</span>
                </span>
              </span>
            </Link>
          )}
        </div>
      </StyledComponent.ModalContainerInsider>
    </StyledComponent.ModalContainer>
  );
};

/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
interface ComponentInterface {
  cameraparams?: string;
  onResetCamera?: any;
  onResetSection?: any;
  isVisible?: boolean;
}
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@sharded/widgets/modal/segmented-twice/component.tsx